import request from '@/utils/request.js';
import Qs from 'qs';

/**
 * 物业项目信息维护
 */
export class PropertyProjectControllerSvr {
  constructor() {
    this.baseurl = 'PropertyProjectControllerSvr.assx/';
  }


  /**
   * 获取待审批和已审批和审批拒绝的审批列表总数
   * ywdId:String, type:String, openId:String, token:String
   */
  getAuditOfEaAreaDetailByYwdId (ywdId, type, openId, token, districtType) {
    return request.post(this.baseurl + 'getAuditOfEaAreaDetailByYwdId', Qs.stringify({ ywdId: ywdId, type: type, openId: openId, token: token, districtType: districtType }));
  }

  /**
   * 获得待审批业务数量
   * openId:String, token:String
   */
  getAuditOfPendCount (openId, token) {
    return request.post(this.baseurl + 'getAuditOfPendCount', Qs.stringify({ openId: openId, token: token }));
  }

  /**
   * 相似物业区域列表
   * openID:String, ywdId:String, token:String
   */
  GetSameEaAreaList (openID, ywdId, token, districtType) {
    return request.post(this.baseurl + 'GetSameEaAreaList', Qs.stringify({ openID: openID, ywdId: ywdId, token: token, districtType: districtType }));
  }

  /**
   * 获取项目信息
   * token:String, orgCode:String
   */
  GetProjectInfo (token, orgCode) {
    return request.post(this.baseurl + 'GetProjectInfo', Qs.stringify({ token: token, orgCode: orgCode }));
  }

  /**
   * 提交物业项目
   * token:String, propertyProject:PropertyProject
   */
  SubmitPropertyProject (token, propertyProject) {
    return request.post(this.baseurl + 'SubmitPropertyProject', Qs.stringify({ token: token, propertyProject: typeof propertyProject === 'undefined' || propertyProject === null ? '' : propertyProject.toString() }));
  }

  /**
   * 获取物业项目列表
   * token:String, eaAreaCode:String, eaAreaName:String, orgCode:String, startIndex:int, maxSize:int
   */
  GetProjectDetailsList (token, eaAreaCode, eaAreaName, orgCode, startIndex, maxSize) {
    return request.post(this.baseurl + 'GetProjectDetailsList', Qs.stringify({ token: token, eaAreaCode: eaAreaCode, eaAreaName: eaAreaName, orgCode: orgCode, startIndex: startIndex, maxSize: maxSize }));
  }

  /**
   * 获取服务企业信息
   * token:String, companyName:String
   */
  getCompaniesData (token, companyName) {
    return request.post(this.baseurl + 'getCompaniesData', Qs.stringify({ token: token, companyName: companyName }));
  }

  /**
   * 添加物业项目
   * token:String, projectDetailsID:String
   */
  DetelProjectDetails (token, projectDetailsID) {
    return request.post(this.baseurl + 'DetelProjectDetails', Qs.stringify({ token: token, projectDetailsID: projectDetailsID }));
  }

  /**
   * 修改待审批物业项目信息
   * openId:String, propertyProject:PropertyProject, type:String, token:String
   */
  modifyAuditOfEaArea (openId, propertyProject, type, token) {
    return request.post(this.baseurl + 'modifyAuditOfEaArea', Qs.stringify({ openId: openId, propertyProject: typeof propertyProject === 'undefined' || propertyProject === null ? '' : propertyProject.toString(), type: type, token: token }));
  }

  /**
   * 审批新增或编辑的物业项目信息
   * openID:String, ywdId:String, reviewContent:String, reviewStatus:int, hmfsBasVillageCode:String, token:String, wybh:String
   */
  putAuditOfEaAreaResult (openID, ywdId, reviewContent, reviewStatus, hmfsBasVillageCode, token, wybh) {
    return request.post(this.baseurl + 'putAuditOfEaAreaResult', Qs.stringify({ openID: openID, ywdId: ywdId, reviewContent: reviewContent, reviewStatus: reviewStatus, hmfsBasVillageCode: hmfsBasVillageCode, token: token, wybh: wybh }));
  }
  /**
   * 区级审批编辑的物业项目信息
   * token:String, ywdId:String, reviewContent:String, reviewStatus:int
   */
  districtPutAuditOfEaAreaResult (token, ywdId, reviewContent, reviewStatus) {
    return request.post(this.baseurl + 'districtPutAuditOfEaAreaResult', Qs.stringify({ token: token, ywdId: ywdId, reviewContent: reviewContent, reviewStatus: reviewStatus }));
  }
  /**
   * 同步物业项目
   * openID:String, propertyProjectCode:String, code:String
   */
  SynPropertyProject (openID, propertyProjectCode, code) {
    return request.post(this.baseurl + 'SynPropertyProject', Qs.stringify({ openID: openID, propertyProjectCode: propertyProjectCode, code: code }));
  }

  /**
   * 添加物业项目
   * token:String, projectDetails:ProjectDetails
   */
  AddProjectDetails (token, projectDetails) {
    return request.post(this.baseurl + 'AddProjectDetails', Qs.stringify({ token: token, projectDetails: typeof projectDetails === 'undefined' || projectDetails === null ? '' : projectDetails.toString() }));
  }

  /**
   * 获取相同宗地号维修资金物业区域列表
   * openID:String, landNum:String, startIndex:int, maxSize:int, resultTotalCount:boolean, token:String
   */
  GetHmfsBasVillageList (openID, landNum, startIndex, maxSize, resultTotalCount, token) {
    return request.post(this.baseurl + 'GetHmfsBasVillageList', Qs.stringify({ openID: openID, landNum: landNum, startIndex: startIndex, maxSize: maxSize, resultTotalCount: resultTotalCount, token: token }));
  }

  /**
   * 修改物业项目
   * token:String, projectDetails:ProjectDetails
   */
  ModifyProjectDetails (token, projectDetails) {
    return request.post(this.baseurl + 'ModifyProjectDetails', Qs.stringify({ token: token, projectDetails: typeof projectDetails === 'undefined' || projectDetails === null ? '' : projectDetails.toString() }));
  }

  /**
   * 市局账号新增物业项目，无需审核
   * token:String, propertyProject:PropertyProject
   */
  submitProjectPass (token, propertyProject) {
    return request.post(this.baseurl + 'SubmitProjectPass', Qs.stringify({ token: token, propertyProject: typeof propertyProject === 'undefined' || propertyProject === null ? '' : propertyProject.toString() }));
  }

  /**
   * 获取待审批或已审批或审批拒绝的审批列表
   * openID:String, eaAreaName:String, contactPerson:String, contactTel:String, auditStatus:int, cantonCode:String, type:String, reviewPerson:String, startTime:Date, endTime:Date, startIndex:int, maxSize:int, token:String
   */
  getAuditOfEaAreaVOList (openID, eaAreaName, contactPerson, contactTel, auditStatus, cantonCode, type, reviewPerson, startTime, endTime, startIndex, maxSize, token) {
    return request.post(this.baseurl + 'getAuditOfEaAreaVOList', Qs.stringify({ openID: openID, eaAreaName: eaAreaName, contactPerson: contactPerson, contactTel: contactTel, auditStatus: auditStatus, cantonCode: cantonCode, type: type, reviewPerson: reviewPerson, startTime: startTime, endTime: endTime, startIndex: startIndex, maxSize: maxSize, token: token }));
  }
  /**
    * 获取区局审批列表
    * token:String, eaAreaName:String, contactPerson:String, contactTel:String, auditStatus:int, type:String, reviewPerson:String, startTime:Date, endTime:Date, startIndex:int, maxSize:int
    */
  getDistrictEaAreaChangeCheckList (token, eaAreaName, contactPerson, contactTel, auditStatus, type, reviewPerson, startTime, endTime, startIndex, maxSize) {
    return request.post(this.baseurl + 'getDistrictEaAreaChangeCheckList', Qs.stringify({ token: token, eaAreaName: eaAreaName, contactPerson: contactPerson, contactTel: contactTel, auditStatus: auditStatus, type: type, reviewPerson: reviewPerson, startTime: startTime, endTime: endTime, startIndex: startIndex, maxSize: maxSize }));
  }
  
  /**
     * 编辑项目时，判断是否能修改单一业主字段
     * token:String, eaAreaCode:String
     */
  querySingleFlagByEaAreaCode(token, eaAreaCode){
      return request.post(this.baseurl + 'querySingleFlagByEaAreaCode', Qs.stringify({ token:token, eaAreaCode:eaAreaCode }));
  }

  /**
   * 获取待审批和已审批和审批拒绝的审批列表总数
   * openID:String, token:String
   */
  getAuditOfEaAreaVOListCount (openID, token) {
    return request.post(this.baseurl + 'getAuditOfEaAreaVOListCount', Qs.stringify({ openID: openID, token: token }));
  }

  /**
   * 获取待审批和已审批和审批拒绝的审批列表总数
   * token:String, ywdId:String
   */
  getDistrictEaAreaChangeCheck (token, ywdId) {
    return request.post(this.baseurl + 'getDistrictEaAreaChangeCheck', Qs.stringify({ token: token, ywdId: ywdId }));
  }

  /**
   * 获取物业企业项目列表
   * orgName:String, areaName:String, cantonName:String, startIndex:int, maxSize:int
   */
  GetPrejectDetailList (orgName, areaName, cantonName, startIndex, maxSize) {
    return request.post(this.baseurl + 'GetPrejectDetailList', Qs.stringify({ orgName: orgName, areaName: areaName, cantonName: cantonName, startIndex: startIndex, maxSize: maxSize }));
  }

  /**
   * 市局账号修改物业项目，无需审核
   * token:String, eaAreaChangeCheck:EaAreaChangeCheck
  //  */
  // modifyProjectPass(token, eaAreaChangeCheck){
  //     return request.post(this.baseurl + 'modifyProjectPass', Qs.stringify({ token:token, eaAreaChangeCheck:typeof eaAreaChangeCheck === 'undefined' || eaAreaChangeCheck === null ? '' : eaAreaChangeCheck.toString() }));
  // }

  /**
   * 获取物业项目
   * projectDetailsID:String
   */
  GetProjectDetails (projectDetailsID) {
    return request.post(this.baseurl + 'GetProjectDetails', Qs.stringify({ projectDetailsID: projectDetailsID }));
  }

  // /**
  //  * 获取公司列表
  //  * openId:String
  //  */
  //  getCompaniesData(token,companyName){
  //     return request.post(this.baseurl+'getCompaniesData',Qs.stringify({token,companyName}))
  // }

  /**
   * 提交物业项目（市项目编辑）
   * openID:String, propertyProject:PropertyProject
   */
  SubmitProjectPass (token, propertyProject) {
    return request.post(this.baseurl + 'SubmitProjectPass', Qs.stringify({
      token,
      propertyProject: typeof propertyProject === 'undefined' || propertyProject === null ? '' : JSON.stringify(propertyProject),
    }));
  }

  //   /**
  //  * 获取项目信息
  //  * token:String
  //  */
  //    GetProjectInfo(token,orgCode) {
  //     return request.post(this.baseurl + 'GetProjectInfo', Qs.stringify({token,orgCode}));
  // }

  modifyProjectPass (token, areaVO) {
    return request.post(this.baseurl + 'modifyProjectPass', Qs.stringify({ token, areaVO: JSON.stringify(areaVO) }));
  }

}
